export default function ()
{
    var bee = '';
    var beeConfig = {  
        container: 'bee-plugin-container',
        autosave: 15, 
        language: 'it-IT',
        contentDefaults: {
            paragraph: {
                styles: {
                    color: '#000000',
                    fontSize: '20px',
                    fontFamily: 'TimesNew Roman',
                    fontWeight: '400',
                    lineHeight: '150%',
                    textAlign: 'left',
                    direction: 'ltr',
                    letterSpacing: '0px',
                    linkColor: '#0068a5',
                    paragraphSpacing: '16px',
                  },
                  blockOptions: {
                    paddingTop: '10px',
                    paddingRight: '10px',
                    paddingBottom: '10px',
                    paddingLeft: '10px',
                  },
                  mobileStyles: {
                    textAlign: "right",
                    fontSize: "50px",
                    paddingTop: "60px",
                    paddingRight: "60px",
                    paddingBottom: "60px",
                    paddingLeft: "60px",
                  },
              }
        },
        editorFonts: {
            showDefaultFonts: true,        
            customFonts: [
            {
                name: "Work Sans",
                fontFamily: "Work Sans",
                url: "https://fonts.googleapis.com/css?family=Work+Sans"
            }]
    },
    trackChanges: true,
    onSave: function(jsonFile, htmlFile) {
        var htmlfile_modified = htmlFile.replace(/<title>.*<\/title>/,'');
        $('#template_html').val(htmlfile_modified);
        $('#template_json').val(jsonFile);
        $('#edit-lettera').submit();
    },
    onSaveAsTemplate: function(jsonFile) { // + thumbnail? 
        
    },
    onAutoSave: function(jsonFile) { // + thumbnail? 
        console.log(new Date().toISOString() + ' autosaving...');
    },
    onSend: function(htmlFile) {
        //write your send test function here
    },
    onChange: function (jsonFile, response) { 
        console.log(response);
    },
    onError: function(errorMessage) {
        console.log('onError ', errorMessage);
    }
    };

    var request = function(method, url, data, type, callback) {
        var req = new XMLHttpRequest();
        console.log(type);
        req.onreadystatechange = function() {
        if (req.readyState === 4 && req.status === 200) {
            var response = JSON.parse(req.responseText);
            callback(response);
        }
        };

        req.open(method, url, true);
        if (data && type) {
        if(type === 'multipart/form-data') {
            var formData = new FormData();
            for (var key in data) {
            formData.append(key, data[key]);
            }
            data = formData;          
        }
        else {
            req.setRequestHeader('Content-type', type);
        }
        }

        req.send(data);
    };

    $('.loader-container').removeClass('d-none');


    BeePlugin.create({
        v2:true,
        access_token: access_token
    }, beeConfig, function(beePluginInstance) {
        bee = beePluginInstance;

        $('#integrator-bottom-bar').css('display','block');
        $('#bee-plugin-container').show();
        $('body').css('overflow','hidden');
        bee.start( JSON.parse($('#template_json').val()) );
        $('.loader-container').addClass('d-none');
    });

    var json_open = 0;

    function readURL(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            reader.readAsText(input.files[0], "UTF-8");

            reader.onload = function(e) {
                try {
                    JSON.parse(e.target.result);
                    json_open = 1;
                    old_template = $('#template_json').val();
                    $('#template_json').val(e.target.result);
                    bee.start(JSON.parse($('#template_json').val()));
                } catch (e) {
                    Swal.fire(translations.application.label_error, translations.application.template_file_invalid, 'error');
                }
            }
        }
    }

    
    $(document).on('change','#json_file', function() {
        var file = this;
        Swal.fire({
            title: translations.application.import_template,
            text: translations.application.prev_template_lost,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: translations.application.si_label,
            cancelButtonText: translations.application.no_label
        }).then(function (result) {
            if (result.value) {	
                readURL(file);		
            }
        });
    });

            
    $(document).on('click','#import',function() {
        $('#json_file').click();
    });

    $(document).on('click','#export',function() {
        bee.save();
        try {
            JSON.parse($('#template_json').val());
            var blob = new Blob([$('#template_json').val()],
            { type: "text/plain;charset=utf-8" });
            saveAs(blob, "untitled.btpl");
        } catch(e) {
        
            Swal.fire(translations.application.label_warning, translations.application.template_empty_import,'danger');
        }
    });

    $(document).on('click','#exit',function(){
        Swal.fire({
            title: translations.application.exit,
            text: translations.application.changes_lost,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: translations.application.si_label,
            cancelButtonText: translations.application.no_label
            }).then(function (result) {
                if (result.value) {	
                    $('#integrator-bottom-bar').css('display','none');
                    $('#bee-plugin-container').css('display','none');
                    $('body').css('overflow','auto');
                    if (old_template != '') {
                        //Se presente ripristina il vecchio template
                        $('#template_json').val(old_template);
                        old_template = '';
                    }
                    $('#sendmessageform').trigger('submit');
                    exit_save = 0;

                    window.location.href = '/admin/commissions/detail/'+id_commissione;
                
                }
            });
        })
        
        $(document).on('click','#preview',function(){
            bee.preview();
        })

        $(document).on('click','#save',function(e) {

            if (old_template != '') {
                old_template = '';
            }

        bee.save();
    });

    $('#edit-lettera').on('submit', function(e) {
        e.preventDefault();

        var data = new FormData(this);

        $.ajax({
            url:'/ajax/createOrUpdateLettera',
            dataType:'JSON',
            method:'POST',
            data:data,
            processData: false,
            contentType: false,
            success:function(response) {
                $('#id_mossa').val(response.id_mossa);
            },
            error: function() {
                Swal.fire(
                    translations.application.label_error, 
                    translations.application.update_template_error, 
                    "error"
                );
            }
        })
    })
}